import { StatusCode } from '@wwt/api/base/base'

import * as Errors from '@/shared/lib/errors'

/**
 * We need this wrapper only for check on 202 status and throw SearchWaitError
 *
 * With wretch we cannot process any status is not an error
 */
export const searchResponseWrapper = <T>(response: Response) => {
	if (response.status === StatusCode.SuccessAccepted) {
		throw new Errors.SearchWaitError('Wait', response)
	}

	return response.json() as T
}
